"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/state/globalStore";
import { type UpdateSituationConfigRequest } from "@/generated/fastapi";
import { updateSituationConfig } from "../api/updateSituationConfig";
import { situationsKeys } from "../queries/keys";

export default function useUpdateSituationConfigMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: UpdateSituationConfigRequest) =>
      updateSituationConfig(accessToken, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: situationsKeys.all });
    },
  });
}
